import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { SpsProductBarComponent } from "../components/index";

@NgModule({
    imports: [CommonModule, RouterModule],
    declarations: [SpsProductBarComponent],
    exports: [SpsProductBarComponent]
})
export class SpsProductBarModule {}
